/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  auth: {
    domain: "portalclientes-auth0.bd.com",
    clientId: "h2ybsF9So7fWgcOyWMK5FtdYa5ywF5WV",
    audience: 'https://nexola.bd.com/',
    serverUrl: 'https://nexola.bd.com/',
    redirectUri: 'https://nexola.bd.com/#/pages/dashboard',
    httpInterceptor: {
      allowedList: ['https://nexola.bd.com/api/*'],
    },
    },
    urlSSO: 'https://portalclientes.bd.com/sso/api/user/',
  apiEndPoint: 'https://nexola.bd.com/',
  logInOut: 'https://nexola.bd.com/#/bienvenido',
  activacionUsuario: 'https://nexola.bd.com/#/activar-usuario',
};
